/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/itp-sign/itpSignState.ts
 * FILE_ID: JOBHUB-QA-ITP-SIGN-STATE-001
 * PURPOSE: Place a pending signature and accept or reject it.
 */
import { buildPresetSignatureItems } from '@quotech/email-hub/feature/components/presetSignaturePlacement'
// Reused from: packages/email-hub/src/feature/components/presetSignaturePlacement.ts (bottomRightPlacement) as the slot 0 origin.
import type { EditorItem, RenderedPage } from '@quotech/email-hub/feature/components/_pdfTypes'
import { resolveSignPages, type SignPageChoice } from '../itp-export/itpSignPages'

export function itemsFromPreset(
  pages: RenderedPage[],
  pngBytes: Uint8Array,
  choice: SignPageChoice,
): EditorItem[] {
  const pageIndices = resolveSignPages(choice, pages.length).map((page) => page - 1)
  return buildPresetSignatureItems(pages, { pngBytes, pageIndices })
}

export function markId(prefix: string, pageIndex: number): string {
  return `${prefix}-${pageIndex}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`
}

export function offsetForSlot(items: EditorItem[], slot: number, pages: RenderedPage[]): EditorItem[] {
  const col = slot % 2
  const row = Math.floor(slot / 2)
  return items.map((item) => {
    const page = pages.find((candidate) => candidate.pageIndex === item.pageIndex)
    const width = page?.widthPt ?? item.xPt + item.widthPt
    const height = page?.heightPt ?? item.yPt + item.heightPt
    return {
      ...item,
      xPt: Math.min(Math.max(0, item.xPt - col * 196), Math.max(0, width - item.widthPt)),
      yPt: Math.min(Math.max(0, item.yPt - row * 90), Math.max(0, height - item.heightPt)),
    }
  })
}

export function acceptMark(pendingIds: string[], id: string): string[] {
  return pendingIds.filter((item) => item !== id)
}

export function rejectMark(
  items: EditorItem[],
  pendingIds: string[],
  id: string,
): { items: EditorItem[]; pendingIds: string[] } {
  return {
    items: items.filter((item) => item.id !== id),
    pendingIds: pendingIds.filter((item) => item !== id),
  }
}
